// extracted by mini-css-extract-plugin
export default {"scale-in":"PageTransition_scale-in__0EIS0","slide-in":"PageTransition_slide-in__lB4pG","slide-out":"PageTransition_slide-out__MRSi3"};